module.exports = __webpack_public_path__ + "img/pic_jinghuaru1.40c9081b.png";